// @flow

import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import IntroTeaser from '../../IntroTeaser'
import messages from './VacancyIntro.lang'
import baseStyles from './VacancyIntro.scss'

const introImage = (
  <StaticImage src="../../../images/pictures/project_manager_image.jpg" objectFit="cover" alt="" className="image" />
)

type Props = {
  ...StyleProps,
  title: string,
  emailMessage?: string,
  hideMail?: boolean,
  info: Object,
  anchor?: string
}

const VacancyIntro = ({ styles, title, emailMessage, info, anchor, hideMail }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <IntroTeaser
      styles={styles.root}
      title={title}
      copy={
        <>
          {info}
          {!hideMail && <p className={styles.emailInfo}>
            {emailMessage ? emailMessage : formatMessage(messages.email)}
            <a
              href="mailto: recruiting@freshcells.de"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.emailLink}
            >
              recruiting@freshcells.de
            </a>
          </p>}
        </>
      }
      image={introImage}
      btn={formatMessage(messages.btn)}
      btnIcon="icon-arrow_03-down-medium"
      btnAnchor={anchor}
      fullWidth
    />
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(VacancyIntro)
